module.exports = __webpack_public_path__ + "img/reward-coupon-icon.ea6c196e.svg";